export const data=[
    {
        imgSrc:require('../../../assets/simpleStack.png'),
        code:`import { BarChart } from "react-native-gifted-charts";
        
const App = () => {
    const stackData = [
        {
          stacks: [
            {value: 10, color: 'orange'},
            {value: 20, color: '#4ABFF4', marginBottom: 2},
          ],
          label: 'Jan',
        },
        {
          stacks: [
            {value: 10, color: '#4ABFF4'},
            {value: 11, color: 'orange', marginBottom: 2},
            {value: 15, color: '#28B2B3', marginBottom: 2},
          ],
          label: 'Mar',
        },
        {
          stacks: [
            {value: 14, color: 'orange'},
            {value: 18, color: '#4ABFF4', marginBottom: 2},
          ],
          label: 'Feb',
        },
        {
          stacks: [
            {value: 7, color: '#4ABFF4'},
            {value: 11, color: 'orange', marginBottom: 2},
            {value: 10, color: '#28B2B3', marginBottom: 2},
          ],
          label: 'Mar',
        },
      ];
    return(
        <View>
            <BarChart
            width={340}
            rotateLabel
            noOfSections={4}
            stackData={stackData}
            />
        </View>
    );
};`
    },
    //1
    {
        imgSrc:require('../../../assets/barb.png'),
        code:`import { BarChart } from "react-native-gifted-charts";
        
const App = () => {
    const barData = [{value: 15}, {value: 30}, {value: 26}, {value: 40}];
    return (
        <BarChart
        frontColor={'#177AD5'}
        barWidth={22}
        data={data}
        />
    );
};`
    },
];

export const sampleStackData = `const stackData = [
  {
    stacks: [
      {
        value: 10,
      },
      {
        value: 20,
        marginBottom: 2,
      },
    ],
    spacing: 15,
    label: 'Jan',
  },
  {
    stacks: [
      {value: 10},
      {
        value: 11,
        marginBottom: 2,
      },
      {
        value: 15,
        marginBottom: 2,
      },
    ],
    label: 'Mar',
  },
  {
    stacks: [{value: 14}, {value: 18, marginBottom: 2}],
    spacing: 15,
    label: 'Feb',
  },
  {
    stacks: [{value: 7}, {value: 11, marginBottom: 2}],
    label: 'Mar',
  },
];

return <BarChart stackData={stackData} />`

export const gradientStackData = `const stackData = [
  {
    stacks: [
      {
        value: 10,
      },
      {
        value: 20,
        marginBottom: 2,
      },
    ],
    spacing: 15,
    label: 'Jan',
  },
  {
    gradientColor: 'blue',
    stacks: [
      {value: 10},
      {
        value: 11,
        marginBottom: 2,
      },
      {
        value: 15,
        marginBottom: 2,
      },
    ],
    label: 'Mar',
  },
  {
    stacks: [{value: 14}, {value: 18, gradientColor:'yellow', color: 'green', marginBottom: 2}],
    spacing: 15,
    label: 'Feb',
  },
  {
    stacks: [{value: 7}, {value: 11, marginBottom: 2}],
    label: 'Mar',
  },
];

return <BarChart stackData={stackData} showGradient />`